import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import {IoMdHome} from 'react-icons/io'
import {BsBriefcaseFill} from 'react-icons/bs'
import {FiLogOut} from 'react-icons/fi'
import './index.css'

const Header = props => {
  const onClickLogout = () => {
    Cookies.remove('jwt_token')
    const {history} = props
    history.replace('/login')
  }

  return (
    <nav className="header-container">
      <div className="header-logo-container">
        <Link to="/">
          <img
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
            alt="website logo"
            className="header-logo"
          />
        </Link>
      </div>
      <ul className="header-links">
        <li>
          <Link to="/" className="link-item">
            Home
          </Link>
        </li>
        <li>
          <Link to="/jobs" className="link-item">
            Jobs
          </Link>
        </li>
      </ul>

      <button onClick={onClickLogout} type="button" className="logout-btn">
        Logout
      </button>
      <ul className="mobile-nav">
        <li>
          <Link to="/">
            <IoMdHome className="mobile-icon" />
          </Link>
        </li>

        <li>
          <Link to="/jobs">
            <BsBriefcaseFill className="mobile-icon" />
          </Link>
        </li>

        <li>
          <button
            onClick={onClickLogout}
            type="button"
            className="mobile-logout-btn"
          >
            <FiLogOut className="mobile-icon" />
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default withRouter(Header)
